import React from 'react';
import './ExampleCard.css';

interface ExampleCardProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  onClick: () => void;
}

const ExampleCard: React.FC<ExampleCardProps> = ({ icon, title, subtitle, onClick }) => {
  return (
    <div className="example-card" onClick={onClick}>
      <div className="example-content">
        <div className="example-text-content">
          <h4 className="example-title">{title}</h4>
          <p className="example-subtitle">{subtitle}</p>
        </div>
        {icon && <div className="example-icon">{icon}</div>}
      </div>
    </div>
  );
};

export default ExampleCard;